import ErrorOutlined from "@mui/icons-material/ErrorOutlined";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { tokens } from "~/locales/tokens";
import {
	useIsFeatureLockedDialogOpen,
	useSetIsFeatureLockedDialogOpen,
} from "~/store";
import { Dialog } from "~served/ui-comps/components/dialog";

export const FeatureRestrictionChecker = () => {
	const { t } = useTranslation();
	const isLocked = useIsFeatureLockedDialogOpen();
	const setIsFeatureLockedDialogOpen = useSetIsFeatureLockedDialogOpen();

	if (isLocked)
		return (
			<Dialog
				dialogProps={{ maxWidth: "xs" }}
				content={
					<Stack
						gap={2}
						alignItems="center">
						<ErrorOutlined
							sx={{ fontSize: "60px", color: (t) => t.palette.primary.main }}
						/>
						<Typography
							variant="body1"
							fontWeight="600">
							Feature is locked. Please upgrade your subscription plan.
						</Typography>
					</Stack>
				}
				actionButtonProps={{
					children: t(tokens.global.close),
					onClick: () => setIsFeatureLockedDialogOpen(false),
				}}
			/>
		);

	return null;
};
